var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 26,
    viewBox: "0 0 18 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.52952 25.3448C3.66467 24.5934 2.41295 23.5836 1.47951 22.1841C-1.05197 18.4793 -0.279237 13.6863 3.37116 10.3963C4.4911 9.38642 5.68935 8.4537 6.80819 7.41683C8.59371 5.78481 9.31287 3.73798 8.88632 1.35457C8.85953 1.17323 8.85953 0.965858 8.83275 0.5C13.8679 4.38608 14.448 8.60767 13.5156 14.0216C14.8948 12.4123 14.3431 13.2169 15.4464 9.7302C19.0433 14.7304 19.4891 23.4272 12.5088 25.5C14.2675 22.3913 13.9213 19.7234 11.123 17.417C9.60435 16.1997 8.2185 14.9554 8.61834 12.7022C5.90241 14.6709 5.82302 17.3908 6.22185 20.3182C5.07614 19.645 4.91646 18.7383 4.75675 17.7535C3.66463 20.2922 3.29168 22.805 5.52952 25.3448Z",
    fill: "url(#paint0_linear_6572_68732)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6572_68732",
    x1: 9,
    y1: 0.5,
    x2: 9,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5CD36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC4B37"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.9f35f0dca6e460727feee7d0ea5e2045.svg";
export { ForwardRef as ReactComponent };